import { render } from "./remappable-buttons.vue?vue&type=template&id=5c2c235e&scoped=true"
import script from "./remappable-buttons.vue?vue&type=script&lang=js"
export * from "./remappable-buttons.vue?vue&type=script&lang=js"

import "./remappable-buttons.vue?vue&type=style&index=0&id=5c2c235e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2c235e"]])

export default __exports__